import { render, staticRenderFns } from "./upload-area-myimp.vue?vue&type=template&id=594ebd3f&scoped=true"
import script from "./upload-area-myimp.vue?vue&type=script&lang=js"
export * from "./upload-area-myimp.vue?vue&type=script&lang=js"
import style0 from "./upload-area-myimp.vue?vue&type=style&index=0&id=594ebd3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594ebd3f",
  null
  
)

export default component.exports